/*
 * @Author: your name
 * @Date: 2020-11-03 15:29:47
 * @LastEditTime: 2021-08-10 10:00:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import {Button, Input, Menu, MenuItem,Link,Checkbox,CheckboxGroup, CheckboxButton, Select, Upload, Popover, RadioButton, Backtop,Breadcrumb,BreadcrumbItem, Loading,  Cascader,Option,Pagination ,Message,Table, TableColumn,Progress, Image,Form,FormItem, Radio, RadioGroup,  MessageBox, Dialog, Tree} from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import MetaInfo from 'vue-meta-info'  
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/main.css'
import './assets/css/public.css'
import './assets/css/basic.css'
import './assets/css/font/iconfont.css'
import 'swiper/css/swiper.css'
import 'monaco-editor/esm/vs/basic-languages/javascript/javascript.contribution';  //引入编辑器
import zh_tran from './assets/lang/lang'

Vue.use(Button);
Vue.use(Input);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Link);
Vue.use(Checkbox);
Vue.use(CheckboxGroup,);
Vue.use(CheckboxButton,);
Vue.use(RadioButton);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Progress);
Vue.use(Image);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Backtop);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Popover);
Vue.use(Dialog);
Vue.use(Upload);
Vue.use(Tree);

Vue.use(Loading.directive);
Vue.use(VueAwesomeSwiper)
Vue.use(MetaInfo)

Vue.prototype.$loading = Loading.service;
Vue.config.productionTip = false
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.prototype.$zh_tran =  zh_tran


Vue.mixin({
  mounted() {
    if(localStorage.getItem('lang') === 'cht') {
      zh_tran(localStorage.getItem('lang'));
    }
  }  
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js